import Cookies from "js-cookie";
import { useEffect } from "react";
import { useAuth } from "./useAuth";

export const useOrganizationAccess = () => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      Cookies.remove("fp_access_token");
      Object.keys(Cookies.get()).forEach((cookieName) => {
        Cookies.remove(cookieName);
      });
      localStorage.clear();
      sessionStorage.clear();
    }
  }, [isAuthenticated]);
};
